<template>
  <div class="app-container">
    <el-button
      size="small"
      type="primary"
      class="go-back"
      @click.stop="goBack()"
    >
      返 回
    </el-button>
    <div style="float: right">
      <el-button type="primary" size="small" @click="updateForums">
        更 新
      </el-button>
      <el-button
              size="small"
              :type="detailForm.isDeleted ? 'warning' : 'danger'"
              @click.stop="deleteOrBackForums(detailForm)"
      >
        {{ detailForm.isDeleted ? "恢复话题" : "删 除" }}
      </el-button>
    </div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>编辑超人圈话题</span>
        <el-button style="float: right; padding: 5px 0;color:#0063d7" type="text" @click="commentDrawer=true">评论区</el-button>
        <el-button style="float: right; padding: 5px 0;padding-right: 10px;color:#0063d7" type="text" @click="fileDrawer=true">文件</el-button>
        <el-button style="float: right; padding: 5px 0;padding-right: 5px;color:#0063d7" type="text"  v-show="detailForm.forumType===6" @click="previewArticle">
          预览文章
        </el-button>
        <el-button style="float: right; padding: 5px 0;padding-right: 5px;color:#0063d7" type="text"  v-show="detailForm.forumType===6" @click="showInsertCsFileDialog()">
          插入客服文档
        </el-button>
      </div>
        <el-form ref="detailForm" :model="detailForm" label-width="120px">
          <el-row>
            <el-col :span="2">
              <el-form-item label="置顶">
                <el-switch
                        v-model="detailForm.isTop"
                        @change="setForums(detailForm, 1)">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item label="推荐">
                <el-switch
                        v-model="detailForm.isRecommended"
                        @change="setForums(detailForm, 2)">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="精华">
                <el-switch
                        v-model="detailForm.isEssential"
                        @change="setForums(detailForm, 0)">
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="仅圈子内可见">
                <el-switch
                        v-model="detailForm.isHideOnSquare"
                        @change="setForums(detailForm, 3)">
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="话题类型" required>
                <el-select v-model="detailForm.categoryId"

                           placeholder="请选择"
                           clearable
                           style="width: 100%"
                           @change="$forceUpdate()"
                >
                  <el-option
                          v-for="item of this.forumCategoryList"
                          :key="item.forumCategoryId"
                          :value="item.forumCategoryId"
                          :label="item.categoryName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item v-if="userDataTypeOptions.length > 0" label="所属领域" label-width="100px" required>
                <el-select
                        v-model="detailForm.userDataType"
                        style="width: 100%"
                >
                  <el-option v-for="item in userDataTypeOptions" :value="item.value" :key="item.value" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="发布圈子(群组)" >
                <el-select v-model="detailForm.forumGroupId"  placeholder="发布到圈子/群组" clearable style="width: 100%" @change="$forceUpdate">
                  <el-option
                      v-for="item of this.allExistForumGroupList"
                      :key="item.forumGroupId"
                      :value="item.forumGroupId"
                      :label="item.groupName"
                  >
                    <img style="width:18px;height:25px;padding-top: 7px" :src="(null===item.groupIcon||''===item.groupIcon)?imageGroupUrl:getImageUrl1(item.groupIcon)">
                    <span>{{' '+item.groupName}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{' 话题:'+item.forumSum+' 成员:'+item.memberSum+''}}</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="数据来源" required v-if="detailForm.forumType!==6">
                <el-select v-model="detailForm.source" style="width: 100%">
                  <el-option label="SIUI分享" :value="0" />
                  <el-option label="用户反馈案列" :value="1" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="标题">
            <el-input v-model="detailForm.customTitle" placeholder="不少于4个字"/>
          </el-form-item>
          <el-form-item label="正文" v-if="detailForm.forumType!==6">
            <el-input
              v-model="detailForm.customDescription"
              type="textarea"
              rows="10"
            />
          </el-form-item>
          <el-form-item label="正文" v-if="detailForm.forumType===6">
            <MyEditor ref="myEditor" />
          </el-form-item>
          <el-form-item label="链接" v-if="detailForm.forumType===1">
            <el-input v-model="detailForm.postUrl" type="textarea" rows="1"/>
          </el-form-item>
        </el-form>
    </el-card>
    <!--右侧抽屉：话题评论-->
    <el-drawer
        title="话题文件"
        :visible.sync="fileDrawer"
        direction="rtl"
        size="35%"
    >
      <el-form ref="detailForm" :model="detailForm" >
        <!--图片视频-->
        <el-form-item >
          <el-upload
              ref="upload"
              :http-request="getOSSUploadInfo"
              action=""
              accept=".jpg,.png,.mp4"
              show-file-list:false
              :limit="1"
              :on-exceed="handleExceed"
              :on-change="onChange"
              :on-remove="onRemove"
              :file-list="uploadFileList"
              :before-upload="beforeUpload"
              :auto-upload="true"
          >
            <div v-show="detailForm.forumType!==6">
              <video id="upvideo" v-if="uploadVideoFileURL !== null" :src="uploadVideoFileURL " controls
                     style="width: 100%;height: 30vh;overflow: auto;" /><br />
              <el-button slot="trigger" style="margin-bottom: 5px;margin-left: 5px" size="small" type="primary">
                上传图片/视频
              </el-button>
              <p v-if="uploadFileLoading">上传中，请稍等片刻...</p>
              <el-progress v-show="percentage !== 0" :percentage="percentage" color="#409eff"></el-progress>
            </div>

          </el-upload>
          <el-table
              :data="forumFileList"
              style="width: 100%;"
              :header-cell-style="{ background: '#F5F7FA' }"
          >
            <el-table-column
                prop="forumFileId"
                label="#"
                align="center"
                width="80"
            />
            <el-table-column label="图片/视频" align="left">
              <template slot-scope="scope">
                <div style="width: 100px; height: 100px;position: relative">
                  <el-image style="width: 100px; height: 100px;" fit="scale-down"
                            @click="previewImage(scope.row)"
                            :src="getImageUrl(scope.row)">
                    <template #error>
                      <p></p>
                    </template>
                  </el-image>
                  <i class="el-icon-video-play"
                     v-if="judgeUrl(scope.row.fileUrl)"
                     style="font-size: 30px;position: absolute;top: 35px;left: 35px;color: black;"
                     @click.stop="previewVideo(scope.row.fileUrl)"></i>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="上传时间" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.createTime | formatDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="70">
              <template slot-scope="scope">
                <el-button
                    icon="el-icon-delete"
                    size="small"
                    type="danger"
                    @click.stop="deleteForumFile(scope.row)"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!--文件-->
        <el-form-item>
          <el-upload
              ref="uploadAccessory"
              :http-request="uploadAccessoryFile"
              action=""
              show-file-list:false
              :limit="1"
              :on-exceed="handleExceed"
              :on-change="onChangeAccessory"
              :on-remove="onRemoveAccessory"
              :file-list="uploadAccessoryFileList"
              :auto-upload="true"
          >
            <div v-show="detailForm.forumType!==6">
              <el-button slot="trigger" style="margin-bottom: 5px;margin-left: 5px" size="small" type="primary">
                上传附件
              </el-button>
              <p v-if="uploadAccessoryLoading">&nbsp附件正在上传中，请稍等片刻...</p>
            </div>
          </el-upload>
          <el-table
              :data="accessoryFileList"
              style="width: 100%;"
              :header-cell-style="{ background: '#F5F7FA' }"
          >
            <el-table-column
                prop="forumAccessoryId"
                label="#"
                align="center"
                width="80"
            />
            <el-table-column label="附件" align="left">
              <template slot-scope="scope">
                <el-button type="text" @click="downloadAccessory(scope.row)">{{scope.row.accessoryName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column label="上传时间" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.createTime | formatDate }}
              </template>
            </el-table-column>
            <el-table-column label="类型" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.resourceType== 1?"客服文档":scope.row.resourceType==2?"设备云盘文件":"普通附件"}}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="70">
              <template slot-scope="scope">
                <el-button
                    size="small"
                    type="danger"
                    icon="el-icon-delete"
                    @click.stop="deleteAccessoryFile(scope.row)"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-drawer>
    <!--右侧抽屉：话题评论-->
    <el-drawer
        title="评论区"
        :visible.sync="commentDrawer"
        direction="rtl"
        size="45%"
    >
      <el-form ref="detailForm" :model="detailForm">
        <el-form-item>
          <el-table
              :data="forumCommentList"
              max-height="100%"
              :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%;"
          >
            <el-table-column
                prop="forumCommentId"
                label="#"
                align="center"
                width="80"
            />
            <el-table-column
                prop="nickname"
                label="用户"
                align="center"
                width="110"
                show-overflow-tooltip
            />
            <el-table-column prop="content" label="评论内容" align="center" />
            <el-table-column label="评论时间" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.createTime | formatDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="145">
              <template slot-scope="scope">
                <el-button
                    size="small"
                    type="primary"
                    @click.stop="openReplyCommentListDialog(scope.row)"
                >
                  回复
                </el-button>
                <el-button
                    size="small"
                    :type="scope.row.isDeleted ? 'warning' : 'danger'"
                    @click.stop="deleteOrBackComment(scope.row)"
                >
                  {{ scope.row.isDeleted ? '恢复' : '删除' }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              v-show="totalCount > pageSize"
              background
              layout="prev, pager, next"
              :total="totalCount"
              :page-size="pageSize"
              :current-page="currentPage"
              @current-change="getForumCommentList"
          />
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog :visible.sync="previewImageDialog" :width="'70%'">
      <div align="center">
      <img :src="Imgsrc" @load="onLoadImg" :height="boxHeight" :width="boxWidth">
      </div>
    </el-dialog>
    <el-dialog title="视频" :visible.sync="previewVideoDialog" width="60%">
      <video :src="getImage1Url(videoSrc)" controls style="width: 100%;height: 60vh;overflow: auto;" controlslist="nodownload" class="video" ></video>
    </el-dialog>
    <el-dialog
            title="评论回复"
            :visible.sync="replyCommentListDialog"
            width="60%"
    >
      <!-- 内容 -->
      <el-table
              :data="replyCommentList"
              :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column prop="forumCommentId" label="#" align="center" />
        +<el-table-column prop="nickname" label="评论者" align="center" />
        <el-table-column prop="content" label="内容" align="center" />
        <el-table-column label="评论时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDateTime }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
              v-show="totalCount > pageSize"
              background
              layout="prev, pager, next"
              :total="totalCountReply"
              :page-size="pageSizeReply"
              :current-page="currentPageReply"
              @current-change="currentChangeReply"
      />
    </el-dialog>
    <el-drawer
        :title="detailForm.customTitle"
        :visible.sync="previewArticleDialog"
        direction="ltr"
        width="30%"
    >
      <div v-html="htmlSrcFrame"></div>
    </el-drawer>
    <el-drawer
        title="客服文档列表"
        :visible.sync="showCsFileDialog"
        direction="rtl"
        size="50%"
    >
      <el-table :data="csFileList" highlight-selection-row height="450">
        <el-table-column property="fileShowName" align="center" label="文件名" ></el-table-column>
        <el-table-column property="fileSuffix" align="center" label="格式" width="100"></el-table-column>
        <el-table-column property="fileSize" align="center" label="大小（MB）" width="100">
          <template slot-scope="scope">
            {{ (scope.row.fileSize / 1024).toFixed(1) }}
          </template>
        </el-table-column>
        <el-table-column property="nickname" align="center" label="上传者" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="上传时间" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="viewFile(scope.row)" >预览</el-button>
            <el-button type="text" @click.stop="quoteFile(scope.row)" >引用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="totalCsFile > 10"  style="margin-top:5px" class="pagination">
        <el-pagination
            background
            layout="prev, pager, next"
            :page-size="10"
            :total="totalCsFile"
            :current-page="pageNumberCsFile"
            @current-change="currentChangeCsFile"
        />
      </div>
      <div style="margin-left: 10px">
        <p style="color: dimgrey;float: left" >共{{totalCsFile}}条</p>
      </div>
    </el-drawer>
    <!--对话框：浏览PDF文件-->
    <el-dialog
        :visible="showPdf === true"
        :append-to-body='true'
        :modal-append-to-body='true'
        :lock-scroll='true'
        :destroy-on-close='true'
        :close-on-click-modal='false'
        width='80%'
        style="z-index: 111"
        :before-close="closePreviewClick"
        top="200px"
        center>
      <div v-if="showPdf === true" class="dialog-body-content-base-style"
           style="justify-content: center; align-items: center">
        <embed :src="this.fileUrl" style="width: 100%; height: 700px"/>
      </div>
    </el-dialog>
    <!--对话框：浏览 视频/图片/音频/文档-->
    <el-dialog
        :append-to-body="true"
        :visible="showDoc === true   || showImg === true || showVideo === true || showMp3 === true"
        :show-close='true'
        width="600"
        style="margin-top: 10px;z-index: 111"
        class="dialog-div-pre-style"
        :before-close="closePreviewClick"
        center>
      <div v-if="showDoc === true" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <iframe frameborder="0"
                :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl"
                width='100%'>
        </iframe>
      </div>
      <div v-else-if="showMp3 === true" align="center" class="dialog-body-content-base-style">
        <audio :src="this.fileUrl" autoplay="autoplay" controls="controls" ref="audio" style="width: 70%"></audio>
      </div>
      <div align="center" style="margin-top: 10px;font-weight: bold">{{this.filePlayName}}</div>
    </el-dialog>
    <canvas id="mycanvas" style="display: none"></canvas>
  </div>

</template>
<script>
import {
  getAllCSDocumentList,
  getOSSUploadInfo,
} from "@/api/system/CSDocument/file";
  import {
    updateForums,
    getOne,
    getForumFileList,
    deleteForumFile,
    getForumCommentList,
    getReplyCommentList,
    deleteOrBackComment, addForumAccessory, getForumAccessoryList, deleteForumAccessory
  } from '@/api/ultrasonicDetail'
  import {
    deleteOrBackForums,
    getForumCategoryList, setForums, addForumFile, getForumConfig, getAllForumGroupList
  } from "@/api/ultrasonic";
import config from "../../../../utils/config";
  import {
    getCloudUrl, getLocalFileURL
  } from "@/utils/urlutil"
import {
	isVaild
} from "@/utils/validate"
import {
  downloadFile,
  uploadFile2OSS
} from "@/utils/OSSUpload";
import {getUserType} from "@/utils/userutil";
import {handleRes, handleResWithReturn} from "@/utils/handleRes";
import MyEditor from "@/components/MyEditor/MyEditor.vue";
import defaultImage from "@/assets/images/grouplogo.png";

  export default {
    components: {MyEditor},
  data() {
    return {
      imageGroupUrl: defaultImage,
      fileDrawer:false,
      commentDrawer:false,
      allForumGroupList1:[], //所有超人圈群组
      allExistForumGroupList:[], //所有未被删除的超人圈群组
      fileFormat:null,
      fileType:0, //文件类型
      forumCategoryList: [], //部位类型
      activeIndex: '0', // 当前索引
      loading: false, // 加载开关
      searchValue: '', // 搜索内容
      totalCount: 0, // 评论列表总数
      pageSize: 10, // 评论单页条数
      currentPage: 1, // 评论当前页码
      totalCountReply: 0, // 评论回复列表总数
      pageSizeReply: 10, // 评论回复单页条数
      currentPageReply: 1, // 评论回复当前页码
      ForumID: '', // 超人圈ID
      detailForm: {}, // 详情表单
      forumFileList: [], // 文件列表
      forumCommentList: [], // 评论列表
      replyCommentList: [], // 评论回复列表
      replyCommentListDialog: false, // 评论回复列表对话框开关
      previewVideoDialog:false,
      previewImageDialog:false,
      videoSrc:"",
      Imgsrc:"",
      picUrlList:[],
      videoUrlList:[],
      ossInfo: "",          // OSS信息
      ossPath: "",          // OSS路径
      uploadFileList:[],
      uploadFileLoading: false,
      uploadAccessoryFileList:[],
      videoCover:null,//视频封面
      uploadVideoFileURL:null,
      uploadVideoFile:null,
      boxWidth: "",
      boxHeight:"",
      userDataTypeOptions:[],

      accessoryFileList:[],
      uploadAccessoryLoading : false,
      percentage: 0,

      forumConfig:{},

      editor:null,//编辑器对象
      editorFileList:[],//编辑器文件
      editorAttachmentList:[],//编辑器附件
      editorCsFileList:[],//编辑器客服文档
      previewArticleDialog:false,
      htmlSrcFrame:"",

      //客服文档对话框参数
      showCsFileDialog: false,
      csFileList: [],
      pageNumberCsFile:1,
      pageSizeCsFile:10,
      totalCsFile:0,

      //浏览文件配置参数
      showMp3:   false,
      showImg:   false,
      showDoc:   false,
      showPdf:   false,
      showVideo: false,
      fileUrl:    "",
      filePlayName:"",      //文件完整名称
    }
  },
  created() {
    this.userDataTypeOptions = getUserType()
    this.ForumID = this.$route.query.forumId
    this.getOne();
    this.getForumCategoryList();
    this.getForumFileList();
    this.getForumCommentList();
    this.getAccessoryFileList();
    this.getForumsConfig();
    this.getAllForumGroupList();
  },
  methods: {
      getImageUrl1(path) {
      return getCloudUrl(path)
    },
    /**
     * 获取所有超人圈群组
     */
    getAllForumGroupList() {
      getAllForumGroupList({
        pageNo: 1
      }).then((res) => {
        return res.data.total
      }).then((res) => {
        return getAllForumGroupList({
          pageSize: res
        })
      }).then((res) => {
        this.allForumGroupList1 = res.data.rows.map((e) => {
          return {
            forumGroupId: e.forumGroupId,
            groupName: e.groupName,
          };
        });
        if(res.data.rows.length>0){
          for(let i=0;i<res.data.rows.length;i++){
            if(res.data.rows[i].isDeleted===false){
              this.allExistForumGroupList.push(res.data.rows[i])
            }
          }
        }
      })
    },

    /**
     * 获取超人圈的配置，如附件大小限制
     */
    getForumsConfig(){
        getForumConfig().then((res) => {
          handleRes(res,()=>{
            this.forumConfig = res.data;
          });
        });
    },
    /**
     * 获取OSS上传信息
     *
     * @param {object} file 文件对象
     */
    getOSSUploadInfo(file) {
      const params = {
        DataType: "5",
        ID: this.ForumID,
      };
      getOSSUploadInfo(params).then((res) => {
        this.ossInfo = res.resultData;
        this.ossPath = res.resultData.PicSavePath;
        this.uploadFileLoading = true
        this.uploadFile(file);
      });
    },
    async uploadAccessoryFile(file){
      this.uploadAccessoryLoading = true;
      const uploadFile = file.file; // 获取上传的file对象
      //大小限制,需转换为M
      // console.log(`uploadAccessoryFile ${uploadFile.size}`)
      // if(uploadFile.size / 1024 / 1024 > this.forumConfig.maxForumAccessorySize){
      //   this.$message(`附件大小不能超过${this.forumConfig.maxForumAccessorySize}M`);
      //   this.uploadAccessoryLoading = false;
      //   return
      // }
      let param = {
        accessoryName:uploadFile.name,
        fileName:uploadFile.name,
        fileSize:uploadFile.size,
        fileSuffix:uploadFile.name.substring(uploadFile.name.lastIndexOf(".")),
        forumId:this.ForumID,
        resourceType:0,
        resourceId:null
      }

      let savepathParamsRes = await getOSSUploadInfo({
        DataType: "12",
        ID: 0,
      });
      if (!isVaild(savepathParamsRes)) {
        this.uploadAccessoryLoading = false;
        return;
      }
      let savePathParams = savepathParamsRes.resultData
      let timestamp = new Date().valueOf();

      let uploadRes;
      let uploadFileName = savePathParams.PicSavePath + timestamp + param.fileSuffix;
        // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
        uploadRes = await uploadFile2OSS(savePathParams,uploadFile, uploadFileName)
      if (uploadRes.status === 0) {
        param.downUrl = "/" + uploadFileName
        // console.log(this.form.liveCover)
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        })
      }
      this.$refs.uploadAccessory.clearFiles();

      let res = await addForumAccessory(param)
      if(handleResWithReturn(res)){
        this.uploadAccessoryFileList = []
        this.$message({
          message: '附件上传成功！',
          type: 'success'
        });
        this.getAccessoryFileList();
      }
      this.uploadAccessoryLoading = false;
    },
    /**
     * 上传服务器
     *
     * @param {object} file 文件对象
     */
    async uploadFile(file) {
      const uploadFile = file.file; // 获取上传的file对象
      const uploadFileSize = uploadFile.size / 1024 / 1024; // 获取上传文件的大小，单位 MB

      if(uploadFile.name.toLowerCase().endsWith(".mp4")){
        console.log(this.uploadVideoFile)
        this.uploadVideoFileURL = getLocalFileURL(this.uploadVideoFile)
        let duration = await this.getVideoDuration(this.uploadVideoFileURL);
        this.uploadVideoTimeLength = duration / 1000;
        // console.log("upload video time length " + duration)
        // if(this.uploadVideoTimeLength > this.forumConfig.maxForumVideoTimeLimit){
        //   this.$message(`视频时长不能超过${this.forumConfig.maxForumVideoTimeLimit}s`);
        //   return;
        // }
        await this.getVideoCover(this.uploadVideoFileURL)
      }

      //传封面
      var coverFileName = null;
      console.log("is vaild " + isVaild(this.videoCover))
      if(isVaild(this.videoCover)){

        let timestamp = new Date().valueOf();
        let data = this.videoCover
        var str = data.split(",");
        var suffix = data.split(";")[0].split("/")[1];
        // console.log("IMG-Suffix====>>", suffix)
        coverFileName = this.ossPath + "cover_from_video_" +
            timestamp + "." + suffix;
        // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)

        //base64
        var buffer = Buffer.from(str[1], 'base64');
        // console.log("upload video cover file " + coverFileName)
        await uploadFile2OSS(this.ossInfo,buffer,coverFileName);
      }
      //传文件
      this.multipartUpload(file,uploadFileSize,isVaild(coverFileName) ? "/"+coverFileName : null);
    },
    /**
     * 分片上传
     */
    async multipartUpload(file,uploadFileSize,videoCover) {
      let OSS = require("ali-oss");
      // 实例化OSS Client。
      let client = new OSS({
        region: this.config.OSS_END_POINT,
        accessKeyId: this.ossInfo.AssumeRoleToken.AccessKeyId,
        accessKeySecret: this.ossInfo.AssumeRoleToken.AccessKeySecret,
        stsToken: this.ossInfo.AssumeRoleToken.SecurityToken,
        bucket: this.config.OSSBUCKET,
        timeout: 600000,
      });

      const options = {
        // 获取分片上传进度、断点和返回值。
        progress:(p) =>{
          //p进度条的值
          this.percentage = parseFloat((p*100).toFixed(0))
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 1024 * 1024,
      };
      let timestamp = new Date().valueOf();
      const fileName = file.file.uid + "_" + timestamp;
      var fileUrl=this.ossPath + fileName;
      if(this.fileFormat !==null){
        fileUrl+="."+this.fileFormat
      }
      client
              .multipartUpload(fileUrl, file.file, options)
              .then((res) => {
                if (res.res.requestUrls) {
                  this.addForumFile("/"+fileUrl,this.ForumID,this.fileType,uploadFileSize*1024,videoCover);

                } else {
                  this.$message.error("Upload failed");
                }
              })
              .catch((err) => {
                console.log("Upload OSS Error:", err);
              });
    },
    addForumFile(fileUrl,forumId,fileType,fileSize,videoCover){
      const params={
        fileUrl:fileUrl,
        forumId:forumId,
        fileType:fileType,
        fileSize:fileSize,
        faceUrl:videoCover
      };
      addForumFile(params).then(() => {
        this.$message({
          message: '文件上传成功！',
          type: 'success'
        });
        this.percentage = 0
        this.uploadFileLoading = false
        this.uploadVideoFileURL=null
        this.uploadFileList = []
        this.getForumFileList();
      });
    },
    /**.then(() => {
     * 上传限制校验
     *
     * @param {object} file 文件对象
     */
    beforeUpload(file) {
      // 文件类型限制
      let exname = file.name.substring(file.name.lastIndexOf(".") + 1);
      const fileTypes = ["mp4","jpg","png"];
      var index=fileTypes.indexOf(exname.toLowerCase())
      if (index < 0) {
        this.$message({
          message: "上传文件只能是 MP4 / JPG / PNG 格式",
          type: "warning",
        });
        return false;
      }
      this.fileFormat=fileTypes[index];
      if(index===0){
        this.fileType=1;
      }
      else{
        this.fileType=0;
      }

      // 文件大小限制
      // const isOverSize = file.size / 1024 / 1024 > 50;
      // if (isOverSize) {
      //   this.$message({
      //     message: "文件大小不能超过 50MB",
      //     type: "warning",
      //   });
      //   return false;
      // }
    },
    /**
     * 上传数量限制提示
     */
    handleExceed() {
      this.$message({
        message: "一次只能上传一个文件",
        type: "warning",
      });
    },
    /**
     * 监听移除文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onRemove(file, fileList) {
      this.uploadFileList = fileList;
      this.resetUploadInfo();
    },
    /**
     * 监听移除文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    onRemoveAccessory(file, fileList) {
      this.uploadAccessoryFileList = fileList;
    },
    resetUploadInfo(){
      this.videoCover = null;
      this.uploadVideoFileURL = null
      this.uploadVideoFile = null
    },
    /**
     * 监听上传文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    async onChange(file, fileList) {
      this.resetUploadInfo();
      this.uploadFileList = fileList;
      this.uploadVideoFile = file;

    },
    /**
     * 监听上传文件，更新数组
     *
     * @param {object} file 文件对象
     * @param {array} fileList 文件对象列表
     */
    async onChangeAccessory(file, fileList) {
      this.uploadAccessoryFileList = fileList;
    },
    /**
     * 延时，保证视频加载完，可以拿到视频cover
     * @param url
     * @returns {Promise<unknown>}
     */
    getVideoDuration(url) {

      return new Promise((reslove) => {
        let video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.onloadedmetadata = () => {
          reslove(parseInt((video.duration * 1000).toString(), 10));
          video = null;
        };
      });
    },
    getVideoCover(url) {
      return new Promise((resolve) => {
        let video = document.getElementById("upvideo"); // 获取视频对象
        // const video = document.createElement("video") // 也可以自己创建video
        // console.log('----- getVideoCover ' + video)

        video.src = url; // url地址 url跟 视频流是一样的
        var canvas = document.getElementById("mycanvas"); // 获取 canvas 对象
        const ctx = canvas.getContext("2d"); // 绘制2d
        video.crossOrigin = "anonymous"; // 解决跨域问题，也就是提示污染资源无法转换视频
        video.currentTime = 1; // 第一帧
        video.oncanplay = () => {
          canvas.width = video.clientWidth; // 获取视频宽度
          canvas.height = video.clientHeight; //获取视频高度
          // 利用canvas对象方法绘图
          ctx.drawImage(video, 0, 0, video.clientWidth, video.clientHeight);
          // 转换成base64形式
          this.videoCover = canvas.toDataURL("image/png"); // 截取后的视频封面
          resolve();
          // video = null;
          console.log("getVideoCover "+this.videoCover)
        };
      });

    },
    /**
     * 删除/恢复帖子
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackForums(row) {
      // 判断操作类型
      let tips1, tips2;
      if (row.isDeleted) {
        tips1 = "是否恢复该帖子";
        tips2 = "恢复成功";
      } else {
        tips1 = "是否删除该帖子";
        tips2 = "删除成功";
      }

      const params = {
        forumId: row.forumId,
      };
      this.$confirm(tips1, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            deleteOrBackForums(params).then(() => {
              this.$message({
                type: "success",
                message: tips2,
              });
              this.refreshCurrentList();
            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },
    /**
     * 设置帖子状态
     *
     * @param {object} row 所选对象信息
     * @param {number} type 所选状态类型
     */
    setForums(row, type) {
      const data = {
        forumId: row.forumId,
        categoryId:row.categoryId,
        customTitle:row.customTitle
      };
      if(type===0){
        //精华
        data.isEssential=row.isEssential !== false
      }
      else if(type===1){
        //置顶
        data.isTop=row.isTop!== false
      }
      else if (type===2){
        //推荐
        data.isRecommended=row.isRecommended!== false
      }
      else if (type===3){
        //广场显示
        data.isHideOnSquare=row.isHideOnSquare!==false
        if(data.isHideOnSquare===true && (this.detailForm.forumGroupId===null||this.detailForm.forumGroupId==='')){
          this.detailForm.isHideOnSquare=!this.detailForm.isHideOnSquare
          this.$message({
            type: "warning",
            message: "您选择了不在广场显示,需请选择一个您要发布的圈子",
          });
          return;
        }
      }else if(type === 4){
        //数据来源
        data.source = row.source
      }
      setForums(data).then(() => {
        this.$message({
          type: "success",
          message: "设置成功",
        });
      });
    },
    getImage1Url(row){
      return getCloudUrl(row);
    },
    showImage(row){
      if(row.faceUrl===""){
          window.open(config.RESOURCES +row.fileUrl);
      }
      else{
        window.open(config.RESOURCES +row.faceUrl);
      }
    },

    onLoadImg: function (e) {
      const imgURL=this.Imgsrc;
      const res = new Image();
      res.src = imgURL;
      if(res.naturalHeight/res.naturalWidth>1){
        this.boxHeight=650 +'px';
        this.boxWidth=Math.floor(650*res.naturalWidth/res.naturalHeight) +'px';
      }
      else if(res.naturalHeight/res.naturalWidth===1){
        if(res.naturalHeight>650){
          this.boxHeight=650 +'px';
          this.boxWidth=650 +'px';
        }
        else{
          this.boxWidth=res.naturalWidth + 'px';
          this.boxHeight=res.naturalHeight +'px';
        }
      }
      else if(res.naturalWidth/res.naturalHeight>1){
        this.boxWidth=900 +'px';
        this.boxHeight=Math.floor(900*res.naturalHeight/res.naturalWidth) +'px';
      }
      this.$forceUpdate();
    },

    /**
     * 预览视频
     *
     * @param {object} row 所选对象信息
     */
    previewVideo(url) {
      this.videoSrc = getCloudUrl(url);
      this.previewVideoDialog = true;
    },
    /**
     * 预览图片
     *
     * @param {object} row 所选对象信息
     */
    previewImage(row) {
      this.Imgsrc = this.getImageUrl(row);
      this.previewImageDialog = true;
    },

    getImageUrl(row) {
      if(!isVaild(row.faceUrl)){
        return config.RESOURCES +row.fileUrl
      }
      return config.RESOURCES +row.faceUrl
    },
    judgeUrl(url){
      if(url.includes(".mp4") || url.includes(".MP4") || url.includes(".Mp4")){
        return true;
      }
      return false;
    },
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1)
    },
    /**
     * 获取所有帖子类型
     */
    getForumCategoryList() {
      this.loading = true;
      const params = {
      };
      getForumCategoryList(params).then((res) => {
        this.forumCategoryList = res.data;
        this.utils.stopLoading(this);
      });
    },
    /**
     *
     */
    refreshCurrentList() {
      switch (this.activeIndex) {
        case '0':
          this.getOne()
          break
        case '1':
          this.getForumFileList()
          break
        case '2':
          this.getForumCommentList()
          break
      }
    },
    /**
     * 切换 tab
     */
    handleClick() {
      this.currentPage = 1
      this.searchValue = ''
      this.refreshCurrentList()
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1
      this.refreshCurrentList()
    },
    /**
     * 重置
     */
    reset() {
      this.currentPage = 1
      this.searchValue = ''
      this.refreshCurrentList()
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.refreshCurrentList()
    },
    /**
     * 获取单个帖子详情
     */
    getOne() {
      const params = {
        forumId: this.ForumID
      }
      getOne(params).then(res => {
        this.detailForm = res.data
        if(6===res.data.forumType){
          setTimeout(() => {
            this.editor = this.$refs.myEditor.editor;
            this.$refs.myEditor.html=res.data.htmlJson
          },2000)
        }
      })
    },
    /**
     * 预 览 文 章
     */
    previewArticle(){
      console.log("aaaa")
      let head='<!DOCTYPE html>  <html lang="zh">  <head>  <meta charset="UTF-8">  <meta name="viewport" content="width=device-width, initial-scale=1.0">  <title>文章 - 超人圈 - 麦粒智检 - SIUI汕头超声</title>  <style>  body {   margin: 0;  font-family: Arial, sans-serif;  }  .container {   max-width: 800px;  margin: 0 auto;   padding: 20px;  } p{ line-height: 2;letter-spacing: 1px } .content {  display: flex;   flex-direction: column;  } .content img, .content video {   width: 100%;  height: auto;   }  @media (max-width: 600px) {  .container {  padding: 10px;  }  }  </style>  </head>  <body><div class="container"><div class="content">'
      let tail='</div></div></body></html>'
      let editorHtml=this.$refs.myEditor.editor.getHtml()
      console.log(editorHtml)
      if(editorHtml!='<p><br></p>'){
        this.htmlSrcFrame=head+editorHtml+tail
        this.previewArticleDialog=true
      }
      else{
        this.$message({
          message: "文章没有任何内容！",
          type: "warning",
        });
      }
    },
    /**
     * 更新单个帖子详情
     */
    updateForums() {
      if (this.detailForm.isHideOnSquare === true && null == this.detailForm.forumGroupId) {
        this.$message({
          message: "请选择一个发布话题的圈子！",
          type: "warning",
        });
        return;
      }
      if (this.detailForm.categoryId===undefined || null === this.detailForm.categoryId || '' === this.detailForm.categoryId) {
        this.$message({
          message: "请设置帖子类型！",
          type: "warning",
        });
        return;
      }
      if (null === this.detailForm.customTitle || '' === this.detailForm.customTitle || 4 > this.detailForm.customTitle.length) {
        this.$message({
          message: "请完善标题，要求不少于4个字！",
          type: "warning",
        });
        return;
      }
      if(this.detailForm.forumType===6){
        //文章更新
        this.detailForm.htmlJson=this.editor.getHtml()
        this.detailForm.customDescription=this.editor.getText()
        //话题中删除、新增文章中的（OSS）图片、视频
        this.processDeleteAndAddFile(this.detailForm.forumId)
        //话题中删除、新增文章中的（OSS）附件
        this.processDeleteAndAddAccessoryFileList(this.detailForm.forumId)
        //话题中删除、新增文章中的客服文档附件
        this.processDeleteAndAddCsFileList(this.detailForm.forumId)

        // console.log(this.editor.getElemsByType('image'));
        // console.log(this.editor.getElemsByType('video'));
        // console.log(this.editor.getElemsByType('attachment'));
        // console.log(this.$refs.myEditor.fileInfoList);
        // console.log(this.$refs.myEditor.uploadAccessoryFileList);
      }
      else{
        //普通话题更新
        if(this.detailForm.forumType===1){
          this.detailForm.postURL = this.detailForm.postUrl
          if(this.detailForm.postUrl===undefined||this.detailForm.postUrl===null||this.detailForm.postUrl===""){
            this.$message({
              message: "链接不能为空！",
              type: "warning",
            });
            return;
          }
        }
        else if(this.detailForm.forumType===2){
          if(this.detailForm.resourceID===undefined||this.detailForm.resourceID===null||this.detailForm.resourceID===""){
            this.$message({
              message: "视频ID不能为空！",
              type: "warning",
            });
            return;
          }
        }
      }

      const data = this.detailForm
      updateForums(data).then(() => {
        this.$message({
          type: 'success',
          message: '修改成功！'
        })
      })
    },
    /**
     * 处理文章帖子文件，当文章删除了某些图片、视频，那么需要相应地解绑，当文章新增了图片、视频，那么需要进行与文章id绑定
     * @param forumId
     */ async processDeleteAndAddFile(forumId) {
      // 或取编辑器上传的图片、视频
      this.editorFileList=this.$refs.myEditor.fileInfoList
      // 处理图片、视频上传
      let existFilePath = [] //文章中的文件列表
      let existPicList = this.editor.getElemsByType('image') //文章中的图片列表
      if (existPicList !== null && existPicList.length > 0) {
        for (let i = 0; i < existPicList.length; i++) {
          existFilePath.push(existPicList[i])
        }
      }
      let existVideoList = this.editor.getElemsByType('video') //文章中的视频列表
      if (existVideoList !== null && existVideoList.length > 0) {
        for (let j = 0; j < existVideoList.length; j++) {
          existFilePath.push(existVideoList[j])
        }
      }
      //步骤一：先处理删除图片、视频
      if(this.forumFileList.length>0){
        for(let i=0;i<this.forumFileList.length;i++){
          let storeFileUrl=this.forumFileList[i].fileUrl
          let flag=true
          if(storeFileUrl!==null){
            storeFileUrl=storeFileUrl.substring(storeFileUrl.indexOf('/UploadFiles'))
            for(let j =0;j<existFilePath.length;j++){
              let src=existFilePath[j].src
              if(src!==null){
                src=src.substring(src.indexOf('/UploadFiles'))
                if(src===storeFileUrl){//匹配到说明文章中的这个图片还在
                  flag=false
                  break
                }
              }
            }
          }
          if(flag===true){
            //执行删除文件
            deleteForumFile({forumFileId: this.forumFileList[i].forumFileId})
          }
        }
      }
      //步骤二：再处理新增图片、视频
      if (this.editorFileList.length > 0) {
        for (let i = 0; i < this.editorFileList.length; i++) {
          for (let j = 0; j < existFilePath.length; j++) {
            if (existFilePath[j].src === this.editorFileList[i].fileUrl) {
              //构造传参 fileUrl,videoCover,uploadFileSize,fileType
              let fileUrl = this.editorFileList[i].fileUrl
              if (fileUrl.indexOf('/UploadFiles') > -1) {
                fileUrl = fileUrl.substring(fileUrl.indexOf('/UploadFiles'))
              }
              let videoCover = this.editorFileList[i].cover
              if (undefined !== videoCover && null !== videoCover) {
                //封面url
                if (videoCover.indexOf('/UploadFiles') > -1) {
                  videoCover = videoCover.substring(videoCover.indexOf('/UploadFiles'))
                }
              }
              let uploadFileSize = this.editorFileList[i].size //文件大小
              let fileType = this.editorFileList[i].type.indexOf('image') > -1 ? 0 : (this.editorFileList[i].type.indexOf('video') > -1 ? 1 : null)
              if (null !== fileType) {
                this.addForumFile("/" + fileUrl, forumId, fileType, uploadFileSize, videoCover);
              }
              break;
            }
          }
        }
      }
      setTimeout(() => {
        this.getForumFileList()
        //清空编辑器的文件上传记录，避免重复绑定
        this.$refs.myEditor.fileInfoList = []
        this.editorFileList = []
      }, 2000)
    },
    /**
     * 处理文章帖子附件，当文章删除了附件，那么需要相应地解绑，当文章新增了附件，那么需要进行与文章id绑定
     * @param forumId
     */
    async processDeleteAndAddAccessoryFileList(forumId){
      // 获取编辑器上传的附件
      this.editorAttachmentList = this.$refs.myEditor.uploadAccessoryFileList
      //处理附件上传
      let existAttachmentPath = this.editor.getElemsByType('attachment') //文章中的附件列表
      //步骤一：先处理删除图片、视频
      if(this.accessoryFileList.length>0){
        console.log(this.accessoryFileList)
        for(let i=0;i<this.accessoryFileList.length;i++){
          if(this.accessoryFileList[i].resourceType===1){
            continue
          }
          let storeFileUrl=this.accessoryFileList[i].downUrl
          let flag=true
          if(storeFileUrl!==null){
            storeFileUrl=storeFileUrl.substring(storeFileUrl.indexOf('/UploadFiles'))
            for(let j =0;j<existAttachmentPath.length;j++){
              let src=existAttachmentPath[j].link
              if(src!==null){
                src=src.substring(src.indexOf('/UploadFiles'))
                if(src===storeFileUrl){//匹配到说明文章中的这个图片还在
                  flag=false
                  break
                }
              }
            }
          }
          if(flag===true){
            //执行删除文件
            deleteForumAccessory({
              forumAccessoryId:this.accessoryFileList[i].forumAccessoryId
            })
          }
        }
      }
      //步骤二：处理附件上传
      if (this.editorAttachmentList.length > 0) {
        for (let i = 0; i < this.editorAttachmentList.length; i++) {
          for (let j = 0; j < existAttachmentPath.length; j++) {
            if (existAttachmentPath[j].link === this.editorAttachmentList[i].fileUrl) {
              //构造传参 fileUrl,videoCover,uploadFileSize,fileType
              let fileUrl = this.editorAttachmentList[i].fileUrl
              if (fileUrl.indexOf('/UploadFiles') > -1) {
                fileUrl = fileUrl.substring(fileUrl.indexOf('/UploadFiles'))
              }
              let uploadFileSize = this.editorAttachmentList[i].size //文件大小
              await addForumAccessory({
                accessoryName: this.editorAttachmentList[i].name,
                fileName: this.editorAttachmentList[i].name,
                fileSuffix: '.' + this.editorAttachmentList[i].type,
                fileSize: uploadFileSize,
                forumId: forumId,
                downUrl: fileUrl,
                resourceType:0,
                resourceId:null
              })
              break;
            }
          }
        }
      }
      setTimeout(() => {
        this.getAccessoryFileList()
        //清空编辑器的文件上传记录，避免重复绑定
        this.$refs.myEditor.uploadAccessoryFileList = []
        this.editorAttachmentList = []
      }, 2000)
    },
    /**
     * 处理文章帖子客服文档附件，当文章删除了附件，那么需要相应地解绑，当文章新增了附件，那么需要进行与文章id绑定
     */ async processDeleteAndAddCsFileList(forumId) {
      // 或取编辑器上传的客服文档
      this.editorCsFileList = this.$refs.myEditor.quoteCsFileList
      // 步骤一：处理客服文档附件删除
      let existAttachmentPath = this.editor.getElemsByType('attachment').concat(this.editor.getElemsByType('image')).concat(this.editor.getElemsByType('video')) //文章中的附件列表
      if (this.accessoryFileList.length > 0) {
        console.log(this.accessoryFileList)
        for (let i = 0; i < this.accessoryFileList.length; i++) {
          if (this.accessoryFileList[i].resourceType === 0) {
            continue
          }
          let storeFileUrl = this.accessoryFileList[i].downUrl
          let flag = true
          if (storeFileUrl !== null) {
            storeFileUrl = storeFileUrl.substring(storeFileUrl.indexOf('/UploadFiles'))
            for (let j = 0; j < existAttachmentPath.length; j++) {
              let src = ''
              if (existAttachmentPath[j].type === 'attachment') {
                src = existAttachmentPath[j].link
              } else {
                src = existAttachmentPath[j].src
              }
              if (src !== null) {
                src = src.substring(src.indexOf('/UploadFiles'))
                if (src === storeFileUrl) {//匹配到说明文章中的这个图片还在
                  flag = false
                  break
                }
              }
            }
          }
          if (flag === true) {
            //执行删除文件
            deleteForumAccessory({
              forumAccessoryId: this.accessoryFileList[i].forumAccessoryId
            })
          }
        }
      }
      // 步骤二：处理客服文档附件上传
      if (this.editorCsFileList.length > 0) {
        for (let i = 0; i < this.editorCsFileList.length; i++) {
          if (this.accessoryFileList.length > 0) {
            for (let k = 0; k < this.accessoryFileList.length; k++) {
              if (this.accessoryFileList[k].resourceType === 1 && this.editorCsFileList[i].csFileID === this.accessoryFileList[k].resourceId) {
                continue
                //如果文章附件中已经有这个客服文档了，就不需要再重复绑定了
              }
            }
          }
          for (let j = 0; j < existAttachmentPath.length; j++) {
            let tempUrl = ''
            if (existAttachmentPath[j].type === 'attachment') {
              tempUrl = existAttachmentPath[j].link
            } else {
              tempUrl = existAttachmentPath[j].src
            }
            if (tempUrl === this.editorCsFileList[i].fileUrl) {
              //构造传参 fileUrl,videoCover,uploadFileSize,fileType
              let csFileID = this.editorCsFileList[i].csFileID
              let fileUrl = this.editorCsFileList[i].fileUrl
              if (fileUrl.indexOf('/UploadFiles') > -1) {
                fileUrl = fileUrl.substring(fileUrl.indexOf('/UploadFiles'))
              }
              let uploadFileSize = this.editorCsFileList[i].size //文件大小
              await addForumAccessory({
                accessoryName: this.editorCsFileList[i].name,
                fileName: this.editorCsFileList[i].name,
                fileSuffix: '.' + this.editorCsFileList[i].type,
                fileSize: uploadFileSize,
                forumId: forumId,
                downUrl: fileUrl,
                resourceType: 1,
                resourceId: csFileID
              })
              break;//只要匹配到了就新增，之后跳出循环，保证只新增一次
            }
          }
        }
      }
      setTimeout(() => {
        this.getAccessoryFileList()
        // 清空编辑器的客服文档上传记录，避免重复绑定
        this.$refs.myEditor.quoteCsFileList = []
        this.editorCsFileList = []
      }, 2000)
    },
    /**
     * 获取单个帖子图片列表
     */
    getForumFileList() {
      this.loading = true
      const params = {
        forumId: this.ForumID
      };
      getForumFileList(params).then(res => {
        this.forumFileList = res.data;
        this.utils.stopLoading(this)
      });
      this.picUrlList=[];
      this.videoUrlList=[];
      if(this.forumFileList!==[]){
        for(const temp of this.forumFileList){
          if(temp.faceUrl===""){
            if(temp.fileUrl!==""){
              const FileExt = temp.fileUrl.replace(/.+\./, "");
              if(
                      ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tiff"].indexOf(FileExt.toLowerCase()) > -1
              ){
                this.picUrlList.push(config.RESOURCES+temp.fileUrl)
              }
            }
          }
          else{
            const FileExt = temp.fileUrl.replace(/.+\./, "");
            if(["mp4"].indexOf(FileExt.toLowerCase())>-1){
              this.videoUrlList.push(config.RESOURCES+temp.fileUrl);
            }
          }
        }
        console.log(this.picUrlList);
        console.log(this.videoUrlList);
      }
    },
    /**
     * 删除单个帖子图片
     *
     * @param {object} row 所选对象信息
     */
    deleteForumFile(row) {
      const params = {
        forumFileId: row.forumFileId
      }
      this.$confirm('是否删除该帖子图片', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          deleteForumFile(params).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getForumFileList();
          })
        })
        .catch(() => {
          this.$message('取消操作')
        })
    },
    /**
     * 下载附件
     * @param entity
     */
    downloadAccessory(entity){
      downloadFile(getCloudUrl(entity.downUrl))
    },
    /**
     * 删除帖子附件
     * @param row
     */
    deleteAccessoryFile(row){
      this.$confirm('是否删除该附件', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
          .then(() => {
            deleteForumAccessory({
              forumAccessoryId:row.forumAccessoryId
            }).then((res) => {
              handleRes(res,()=>{
                this.$message({
                  type: 'success',
                  message: '删除成功'
                })
                this.getAccessoryFileList();
              })
            })
          })
          .catch(() => {
            this.$message('取消操作')
          })
    },
    /**
     * 获取单个帖子评论列表
     */
    getForumCommentList(e) {
      this.currentPage=e;
      this.loading = true
      const params = {
        forumId: this.ForumID,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };
      getForumCommentList(params).then(res => {
        this.forumCommentList = res.data.rows
        this.totalCount = res.data.total
        this.utils.stopLoading(this)
      })
    },
    /**
     * 获取帖子附件列表
     */
    getAccessoryFileList(){
      getForumAccessoryList({
        forumId:this.ForumID
      }).then(res=>{
        handleRes(res,()=>{
          this.accessoryFileList = res.data
        })
      })
    },
    /**
     * 删除单个帖子评论
     *
     * @param {object} row 所选对象信息
     */
    deleteOrBackComment(row) {
      // 判断操作类型
      let tips1, tips2
      if (row.isDeleted) {
        tips1 = '是否恢复该帖子评论'
        tips2 = '恢复成功!'
      } else {
        tips1 = '是否删除该帖子评论'
        tips2 = '删除成功'
      }

      const params = {
        forumCommentId: row.forumCommentId
      };
      this.$confirm(tips1, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          deleteOrBackComment(params).then(() => {
            this.$message({
              type: 'success',
              message: tips2
            })
            this.getForumCommentList()
          })
        })
        .catch(() => {
          this.$message('取消操作')
        })
    },
    /**
     * 打开评论回复对话框
     *
     * @param {object} row 所选对象信息
     */
    openReplyCommentListDialog(row) {
      this.replyCommentListDialog = true;
      this.getReplyCommentList(row)
    },
      currentChangeReply(e){
        this.currentPageReply=e;
        this.getReplyCommentList()
      },
    /**
     * 获取单个评论回复列表
     *
     * @param {object} row 所选对象信息
     */
    getReplyCommentList(row) {
      const params = {
        forumId: row.forumId,
        relativeCommentId: row.forumCommentId,
        pageNumber: this.currentPageReply,
        pageSize: this.pageSizeReply,
      };
      getReplyCommentList(params).then(res => {
        this.replyCommentList = res.data.rows;
        this.totalCountReply = res.data.total;
      })
    },

    /**
     * 打开插入客服文档对话框
     */
    showInsertCsFileDialog() {
      this.showCsFileDialog = true
      this.getCSDocumentList()
    },
    currentChangeCsFile(currentPage){
      this.pageNumber = currentPage;
      this.getCSDocumentList()
    },
    getCSDocumentList(){
      this.csFileList = []
      return new Promise((resolve, reject) => {
        const param = {
          pageNumber: this.pageNumberCsFile,
          pageSize: this.pageSizeCsFile,
          type: 0
        };
        getAllCSDocumentList(param).then((res) => {
          if (res.code === 200) {
            this.csFileList = res.data.rows
            this.totalCsFile = res.data.total
          }
        });
      });
    },
    // 引用客服文档
    quoteFile(row) {
      this.$refs.myEditor.quoteFile(row)
    },
    // 预览文章
    viewFile(row){
      this.filePlayName=row.fileName+row.fileSuffix;
      let type = this.iconByType(row);
      this.fileUrl = this.config.RESOURCES+row.downUrl;
      if (type.indexOf("doc") !== -1 || type.indexOf("docx") !== -1 || type.indexOf("xls") !== -1 || type.indexOf("xlsx") !== -1) {
        this.showDoc = true;
      }
      else if (type.indexOf("pdf") !== -1) {
        this.showPdf = true;
      }
      else if (type.indexOf("jpg") !== -1 || type.indexOf("png") !== -1 || type.indexOf("jpeg") !== -1) {
        this.Imgsrc = this.fileUrl
        this.previewImageDialog=true;
        // this.showImg=true;
      }
      else if (type.indexOf("avi") !== -1 || type.indexOf("mp4") !== -1 || type.indexOf("webm") !== -1 || type.indexOf("m4v") !== -1 || type.indexOf("rmvb") !== -1 || type.indexOf("mpg") !== -1 || type.indexOf("3gp") !== -1 || type.indexOf("swf") !== -1 || type.indexOf("mkv") !== -1) {
        this.videoSrc=row.downUrl;
        this.previewVideoDialog = true;
        // this.showVideo = true;
      }
      else if (type.indexOf("mp3")!== -1){
        this.showMp3 = true;
      }
      else {
        this.$message("当前文件暂不支持预览")
      }
    },
    closePreviewClick() {
      if (this.showDoc === true) {
        this.showDoc = false;
      } else if (this.showPdf === true) {
        this.showPdf = false;
      } else if (this.showMp3 === true) {
        this.showMp3 = false;
      }
    },
    /**
     * 经过文件后缀返回文件的图标
     */
    iconByType(row) {
      return row.fileSuffix.substring(row.fileSuffix.lastIndexOf(".") + 1, row.fileSuffix.length)
    },
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
